module.exports = __webpack_public_path__ + "static/media/Saman Yarmohammadi.c92735e0.png";